export default __webpack_public_path__ + "static/media/50_pc@2x.ea1acd22.png";